<div class="card">
  <div class="card-header d-flex justify-content-between align-items-start">
    <h4>{{ "LAST_BARGAINING" | translate }}</h4>
    <a routerLink="/dashboard/bargaining-list">{{ "VIEW_ALL_FEMALE" | translate }}</a>
  </div>
  <div class="card-body">
    <div *ngIf="barganingList?.length < 1">{{ "ALERT.ERROR_NOT_FOUND_BARGAINING" | translate }}</div>
    <div *ngFor="let bargaining of barganingList" class="row mb-1">
      <div class="col-12">
        <a class="font-weight-medium text-break-line-1 mb-0" [routerLink]="'/dashboard/edit-bargaining/' + bargaining.id">
          {{ bargaining.request_name }}
        </a>
        <div class="d-flex font-small-2 mt-025">
          <!--documenti-->
          <span
            class="badge"
            [ngClass]="{
              'badge-light-secondary': bargaining.status_document == 0,
              'badge-light-info': bargaining.status_document == 1,
              'badge-light-warning': bargaining.status_document == 2,
              'badge-success': bargaining.status_document == 3,
              'badge-light-danger': bargaining.status_document == 4
            }"
            [ngbTooltip]="
              bargaining.status_document == 0
                ? ('NOT_SENDED_PLURAL' | translate)
                : bargaining.status_document == 1
                ? ('SENDED_PLURAL' | translate)
                : bargaining.status_document == 2
                ? ('TO_APPROVED' | translate)
                : bargaining.status_document == 3
                ? ('APPROVED_MALE_PLURAL' | translate)
                : ('NOT_APPROVED_PLURAL_MALE' | translate)
            "
          >
            {{ "DOCUMENTS" | translate }}
          </span>
          <!--contratto-->
          <span
            class="badge ml-1"
            [ngClass]="{
              'badge-light-secondary': bargaining.status_contract == 0,
              'badge-light-info': bargaining.status_contract == 1,
              'badge-light-warning': bargaining.status_contract == 2,
              'badge-success': bargaining.status_contract == 3,
              'badge-light-danger': bargaining.status_contract == 4
            }"
            [ngbTooltip]="
              bargaining.status_contract == 0
                ? ('NOT_SENDED' | translate)
                : bargaining.status_contract == 1
                ? ('SENDED' | translate)
                : bargaining.status_contract == 2
                ? ('TO_APPROVED' | translate)
                : bargaining.status_contract == 3
                ? ('APPROVED' | translate)
                : ('NOT_APPROVED' | translate)
            "
          >
            {{ "CONTRACT" | translate }}
          </span>
          <span class="w-100 text-right">{{ bargaining.user.complete_name }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
